var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "step-1" } }, [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("list-document-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "documentTypes",
            staticClass: "w-100",
            attrs: {
              "type-numeration": _vm.typeNumeration,
              autocomplete: "",
              label: "Tipo Documento (*)",
              name: "documentType",
              danger: _vm.errors.has("step-1.documentType"),
              "danger-text": _vm.errors.first("step-1.documentType")
            },
            model: {
              value: _vm.step.documentType,
              callback: function($$v) {
                _vm.$set(_vm.step, "documentType", $$v)
              },
              expression: "step.documentType"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("list-documents", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: _vm.isRequired },
                expression: "{'required': isRequired}"
              }
            ],
            ref: "documents",
            staticClass: "w-100",
            attrs: {
              "type-numeration": _vm.typeNumeration,
              autocomplete: "",
              label: "Documento (*)",
              name: "document",
              "parent-value": _vm.step.documentType,
              danger: _vm.errors.has("step-1.document"),
              "danger-text": _vm.errors.first("step-1.document")
            },
            model: {
              value: _vm.step.document,
              callback: function($$v) {
                _vm.$set(_vm.step, "document", $$v)
              },
              expression: "step.document"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "vs-select",
            {
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Formato Documento",
                name: "formatDocument"
              },
              model: {
                value: _vm.step.formatDocument,
                callback: function($$v) {
                  _vm.$set(_vm.step, "formatDocument", $$v)
                },
                expression: "step.formatDocument"
              }
            },
            [
              _c("vs-select-item", { attrs: { value: 0, text: "Papel" } }),
              _c("vs-select-item", { attrs: { value: 1, text: "Electrónico" } })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-1" },
            [
              _c(
                "vs-radio",
                {
                  attrs: { "vs-name": "isPrivate", "vs-value": 2 },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" Si ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-1" },
            [
              _c(
                "vs-radio",
                {
                  attrs: { "vs-name": "isPrivate", "vs-value": 1 },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" No ")]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("label", { attrs: { for: "matter" } }, [_vm._v("Materia (*)")]),
          _c("vs-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:3",
                expression: "'required|min:3'"
              }
            ],
            staticClass: "mb-0",
            staticStyle: { resize: "none !important" },
            attrs: {
              type: "text",
              id: "matter",
              label: "Materia (Mínimo 2 palabras, máximo 5000 caracteres)",
              name: "matter",
              width: "100%",
              height: "100px",
              maxlength: "5000"
            },
            model: {
              value: _vm.step.matter,
              callback: function($$v) {
                _vm.$set(_vm.step, "matter", $$v)
              },
              expression: "step.matter"
            }
          }),
          _vm.errors.first("step-1.matter")
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n       vs-input--text-validation-span v-enter-to",
                  staticStyle: { height: "32px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("step-1.matter")) + " "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("label", [_vm._v("Documento Reservado")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }